import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div`
    @media ${getBreakpoint("up", "md")} {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 11;
    }
    @media ${getBreakpoint("up", "lg")} {
        right: 48px; /* 32px (width toggle icon) + spacing (16px) */
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "md")} {
            left: 0;
            right: auto;
        }
        @media ${getBreakpoint("up", "lg")} {
            left: 48px; /* 32px (width toggle icon) + spacing (16px) */
            right: auto;
        }
    }
`;

export const Label = styled.span.attrs(() => ({
    className: "l-sub-micro-text",
}))`
    display: inline-block;
    margin-right: ${theme.space[3]}px;
    color: ${theme.colors.dark};

    html[dir="rtl"] & {
        margin-left: ${theme.space[3]}px;
        margin-right: 0;
    }
`;

export const Status = styled.button.attrs(() => ({
    className: "l-sub-micro-text",
}))<{ isActive?: boolean }>`
    max-height: 32px;
    margin: 0 ${theme.space[2]}px 0 ${theme.space[1]}px;
    padding: 0 ${({ isActive }) => (isActive ? `${theme.space[2]}px` : 0)};
    line-height: 3.2rem; /* Same height as button height */
    color: ${({ isActive }) => (isActive ? theme.colors.lightest : theme.colors.grey3)};
    background-color: ${({ isActive }) => (isActive ? theme.colors.azure : "transparent")};
    border-radius: 20px;
`;
